import React from 'react'

function returnpolicy() {
  return (
    <div>
       <div className="uk-section bg-primary">
            <div className="uk-container">
                <h1 className='text-primary uk-text-capitalize uk-margin-small uk-text-center'>
                    refund & return policy
                </h1>
                <p className='text-secondary uk-text-left uk-text-justify uk-margin-small'>
                  Once a service has been paid for and availed, we at Stratos do not offer refunds under any circumstances. We encourage our customers to review their availing service carefully before making a payment.
                </p>
                <div>
                    <h3 className='text-primary uk-text-capitalize uk-margin-small uk-text-left'>
                      Liability and Insurance:
                    </h3>
                    <p className='uk-text-left text-secondary uk-text-justify uk-margin-small'>
                      Stratos is committed to providing reliable and efficient courier and cargo services. However, Stratos shall not be liable for any loss, damage, or inconvenience caused by events beyond our control, including but not limited to natural disasters, acts of war, and force majeure events.
                    </p>
                </div>
                <div className='uk-text-left'>
                  <h3 className='text-primary uk-text-capitalize uk-margin-small'>
                    Insurance Claims:
                  </h3>
                  <p className='text-secondary uk-text-justify uk-margin-small'>
                    Customers are advised that Stratos does not provide insurance for the goods shipped. It is the customer’s responsibility to secure insurance if they wish to protect their interest in the goods being transported. In the event of any loss or damage where the customer has purchased insurance, the customer should directly contact their insurance provider to file a claim.
                  </p>
                </div>
                <div className='uk-text-left'>
                  <h3 className='text-primary uk-text-capitalize uk-margin-small'>
                  Contacting the Company:
                  </h3>
                  <p className='text-secondary uk-text-justify uk-margin-small'>
                    For any issues or inquiries regarding the services provided, customers are encouraged to get in touch with Stratos customer service. Our team will assist you in resolving your concerns to the best of our abilities.
                  </p>
                </div>
                <div className='uk-text-left'>
                  <h3 className='text-primary uk-text-capitalize uk-margin-small'>
                    Disclaimer:
                  </h3>
                  <p className='text-secondary uk-text-justify uk-margin-small'>
                    Stratos shall not be held liable for any indirect, incidental, consequential, special, or exemplary damages arising from or related to the use of our services. This includes damages that were foreseeable or unforeseeable, and regardless of whether Stratos was informed of the potential for such damages. While we endeavor to secure insurance coverage, it's important to note that the claim amount is subject to the terms and conditions of the insurance policy.
                  </p>
                </div>
            </div>
        </div>
        <div className="uk-section">
            <div className="uk-container">
                <h1 className='text-primary uk-text-capitalize uk-margin-small uk-text-center'>
                    return Of shipment policy
                </h1>
                
                <div>
                    <h3 className='text-primary uk-text-capitalize uk-margin-small uk-text-left'>
                      Failure to Collect Parcel:
                    </h3>
                    <p className='uk-text-left text-secondary uk-text-justify uk-margin-small'>
                      In the event that the consignee fails to collect the parcel at the destination office, a return charge will be applicable to the shipper for returning the shipment to the origin.
                    </p>
                </div>
                <div className='uk-text-left'>
                  <h3 className='text-primary uk-text-capitalize uk-margin-small'>
                    Non-Payment of Return Charges:
                  </h3>
                  <p className='text-secondary uk-text-justify'>
                    Failure to pay the return charges within the specified timeframe will result in the goods not being handed over. Subsequently, the unclaimed goods will be either auctioned or destroyed.
                  </p>
                </div>
                <div className='uk-text-left'>
                  <h3 className='text-primary uk-text-capitalize uk-margin-small'>
                    Time Limit:
                  </h3>
                  <p className='text-secondary uk-text-justify uk-margin-small'>
                    Customers are given a maximum of 7 days at the destination office to collect their parcel. If the parcel remains uncollected after an attempt to deliver beyond this period, it will be returned to the origin.
                  </p>
                </div>
                <div className='uk-text-left'>
                  <h3 className='text-primary uk-text-capitalize uk-margin-small'>
                    Penalties:
                  </h3>
                  <p className='text-secondary uk-text-justify uk-margin-small'>
                    Penalties will be imposed for delays in collecting shipments. Customers must adhere to the specified timelines to avoid these charges
                  </p>
                </div>
                <div className='uk-text-left'>
                  <h3 className='text-primary uk-text-capitalize uk-margin-small'>
                    Further 7 Days at Origin:
                  </h3>
                  <p className='text-secondary uk-text-justify uk-margin-small'>
                    Upon return to origin, the sender will be granted an additional 7 days to collect their parcel. Failure to do so will result in further penalties and subsequent actions as outlined in this policy.
                  </p>
                </div>
            </div>  
        </div>
    </div>
  )
}

export default returnpolicy